import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import {
  BaseButton,
  FilterBottomSheet,
  SCREENS,
  useMediaQuery,
  useT,
} from '@repo/common';

import { ReactComponent as UploadIcon } from '@repo/common/assets/icons/16px/icon_16px_upload.svg';
import { ReactComponent as DeleteIcon } from '@repo/common/assets/icons/16px/icon_16px_delete_outline.svg';

const MENU_WIDTH = 220;

const MenuItem = ({ icon, isDanger = false, onClick, children }) => (
  <li className='flex w-full items-center rounded-lg transition-colors duration-150'>
    <BaseButton
      type='text'
      size='m'
      icon={icon}
      iconPosition='after'
      width='100%'
      separate
      leftalign
      onClick={onClick}
      bgclass='bg-grayscale-gray00 border border-grayscale-gray00'
      textclass={`typo-b14Strong ${isDanger ? 'text-functional-failed03' : ''}`}
      hoverclass={
        isDanger
          ? 'hover:bg-functional-failed01 hover:text-functional-failed03'
          : 'hover:bg-grayscale-gray01 hover:text-text-primary'
      }
      activeclass={
        isDanger
          ? 'active:bg-functional-failed01 active:text-functional-failed04'
          : 'active:bg-grayscale-gray02 active:text-text-primary'
      }
    >
      {children}
    </BaseButton>
  </li>
);

const CompanyLogoMenu = ({ anchorRect, onClose, onUpload, onRemove }) => {
  const t = useT();
  const isMobile = useMediaQuery(`(max-width: ${SCREENS.tabletH - 0.02}px)`);
  const listRef = useRef(null);

  useEffect(() => {
    if (isMobile) return undefined;

    const handleScroll = () => onClose?.();
    window.addEventListener('scroll', handleScroll, true);
    return () => window.removeEventListener('scroll', handleScroll, true);
  }, [onClose, isMobile]);

  const select = (action) => (event) => {
    event.preventDefault();
    event.stopPropagation();
    onClose?.();
    action?.();
  };

  const menuItems = (
    <ul className='flex flex-col'>
      <MenuItem icon={<UploadIcon />} onClick={select(onUpload)}>
        {t('Upload New', '새로 업로드')}
      </MenuItem>
      <MenuItem icon={<DeleteIcon />} onClick={select(onRemove)}>
        {t('Remove', '삭제')}
      </MenuItem>
    </ul>
  );

  if (isMobile) {
    return ReactDOM.createPortal(
      <FilterBottomSheet onClose={onClose}>{menuItems}</FilterBottomSheet>,
      document.body,
    );
  }

  if (!anchorRect) return null;

  const left = Math.max(
    8,
    Math.min(anchorRect.right - MENU_WIDTH, window.innerWidth - MENU_WIDTH - 8),
  );

  return ReactDOM.createPortal(
    <>
      <div
        className='fixed inset-0 z-[999999] bg-transparent'
        onClick={(event) => {
          event.stopPropagation();
          onClose?.();
        }}
      />

      <div
        ref={listRef}
        onClick={(event) => event.stopPropagation()}
        style={{
          position: 'fixed',
          top: anchorRect.bottom + 8,
          left,
          width: MENU_WIDTH,
        }}
        className='
          z-[1000000] rounded-lg border border-grayscale-gray02
          bg-grayscale-gray00 p-2 shadow-popup-04
        '
      >
        {menuItems}
      </div>
    </>,
    document.body,
  );
};

export default CompanyLogoMenu;
